<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        Manage | Create User
      </h2>
      <a v-bind:href="$route('manage.users.create')" class="btn btn-primary btn-lg">
        New User
      </a>
    </div>
  </div>
  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Name</th>
        <th class="hidden lg:table-cell">Title</th>
        <th class="hidden sm:table-cell">Email</th>
        <th>Role</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        <template v-if="users.data.length" v-for="user in users.data">
          <tr>
            <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
              {{ user.name }}
              <dl class="font-normal lg:hidden">
                <dt class="sr-only">Title</dt>
                <dd class="mt-1 truncate text-gray-700">{{ user.title }}</dd>
                <dt class="sr-only sm:hidden">Email</dt>
                <dd class="mt-1 truncate text-gray-500 sm:hidden">{{ user.email }}</dd>
              </dl>
            </td>
            <td class="hidden text-gray-500 lg:table-cell">{{ user.title }}</td>
            <td class="hidden text-gray-500 sm:table-cell">{{ user.email }}</td>
            <td class="text-gray-500">{{ user.role.name }}</td>
            <td class="text-right">
              <a v-bind:href="$route('manage.users.edit', user.id)" class="text-primary-500 hover:text-primary-700">Edit</a>
              <span> | </span>
              <a v-bind:href="$route('manage.users.destroy', user.id)" class="text-danger-500 hover:text-danger-700">Delete</a>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td colspan="5" class="text-center">No users exist</td>
          </tr>
        </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="pagination" />
    </div>
  </div>
</template>

<script setup>
import Pagination from "../../../components/Pagination";

const { users } = defineProps(['users']);
const pagination = Object.assign({}, users);
delete pagination.data;
</script>
